<script setup lang="ts">
import { computed } from 'vue'
import { NConfigProvider, NMessageProvider, NDialogProvider, NLoadingBarProvider, ruRU, dateRuRU } from 'naive-ui'
import { RouterView } from 'vue-router'
import { useTheme } from '@/composables/useTheme'
import { buildThemeOverrides } from '@/utils/naive-theme-overrides'

const { naiveTheme, mode } = useTheme()
const themeOverrides = computed(() => buildThemeOverrides(mode.value))
</script>

<template>
  <n-config-provider :theme="naiveTheme" :theme-overrides="themeOverrides" :locale="ruRU" :date-locale="dateRuRU">
    <n-loading-bar-provider>
      <n-message-provider>
        <n-dialog-provider>
          <RouterView />
        </n-dialog-provider>
      </n-message-provider>
    </n-loading-bar-provider>
  </n-config-provider>
</template>
